import React from "react";
import routes from "../../routes/sidebar";
import { NavLink, Route, useHistory } from "react-router-dom";
import * as Icons from "../../icons";
import SidebarSubmenu from "./SidebarSubmenu";
import { Button } from "@windmill/react-ui";
import { useAdmin } from "../../context/AdminContext";
import { toastError } from "../../helpers/toast";

function Icon({ icon, ...props }) {
  const Icon = Icons[icon];
  return <Icon {...props} />;
}

function SidebarContent() {
  const { signOut } = useAdmin();
  const history = useHistory();
  const currentUser = JSON.parse(sessionStorage.getItem("user")) || {};

  // Define allowed routes for different user types
  const cityUserRoutesList = [
    "Facility",
    "Users",
    "Add User",
    "GRS Doc",
    "Generate Reports",
    "Document",
    "Invoice Generation"
  ];
  const moderatorRoutesList = ["Facility", "Add Facility"];

  // Filter routes based on user role
  let filteredRoutes = routes;

  if (currentUser.role === "city_user") {
    filteredRoutes = routes.filter(
      (route) => cityUserRoutesList.includes(route.name) && !route.adminOnly // Exclude routes marked as adminOnly
    );
  } else if (currentUser.displayName === "moderator") {
    filteredRoutes = routes.filter(
      (route) => moderatorRoutesList.includes(route.name) && !route.adminOnly // Exclude routes marked as adminOnly
    );
  } else if (currentUser.role !== "admin") {
    // For any non-admin user, exclude adminOnly routes
    filteredRoutes = routes.filter((route) => !route.adminOnly);
  }

  const handleSignOut = async () => {
    try {
      await signOut();
      history.push("/login");
    } catch (error) {
      toastError("Failed to sign out");
    }
  };

  return (
    <div className="py-4 text-gray-500 dark:text-gray-400">
      <style>
        {`
          /* Common scrollbar styles for both sidebar and facility */
          .sidebar-content::-webkit-scrollbar,
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          .sidebar-content::-webkit-scrollbar-track,
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #F7FAFC;
            border-radius: 8px;
          }
          .sidebar-content::-webkit-scrollbar-thumb,
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #CBD5E0;
            border-radius: 8px;
            border: 2px solid transparent;
            background-clip: padding-box;
          }
          .sidebar-content::-webkit-scrollbar-thumb:hover,
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #A0AEC0;
            border: 2px solid transparent;
            background-clip: padding-box;
          }
          .sidebar-content::-webkit-scrollbar-corner,
          .custom-scrollbar::-webkit-scrollbar-corner {
            background: transparent;
          }
          .sidebar-content,
          .custom-scrollbar {
            scrollbar-width: thin;
            scrollbar-color: #CBD5E0 #F7FAFC;
          }
          /* Dark mode styles */
          .dark .sidebar-content::-webkit-scrollbar-track,
          .dark .custom-scrollbar::-webkit-scrollbar-track {
            background: #2D3748;
          }
          .dark .sidebar-content::-webkit-scrollbar-thumb,
          .dark .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #4A5568;
          }
          .dark .sidebar-content::-webkit-scrollbar-thumb:hover,
          .dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #718096;
          }
          .dark .sidebar-content,
          .dark .custom-scrollbar {
            scrollbar-color: #4A5568 #2D3748;
          }
        `}
      </style>
      <a
        className="ml-6 text-lg font-bold text-gray-800 dark:text-gray-200"
        href="#"
      >
        Bio Waste Agency
      </a>

      {currentUser.role === "city_user" && (
        <div className="ml-6 mt-2 text-sm text-gray-600">
          {currentUser.assignedCities.map((city, index) => (
            <span
              key={index}
              className="inline-block bg-purple-100 text-purple-800 rounded-full px-2 py-1 text-xs font-semibold mr-1 mb-1"
            >
              {city.charAt(0).toUpperCase() + city.slice(1)}
            </span>
          ))}
        </div>
      )}

      <ul className="mt-6">
        {filteredRoutes.map((route) =>
          route.routes ? (
            <SidebarSubmenu route={route} key={route.name} />
          ) : (
            <li className="relative px-6 py-3" key={route.name}>
              <NavLink
                exact
                to={route.path}
                className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
                activeClassName="text-gray-800 dark:text-gray-100"
              >
                <Route path={route.path} exact={route.exact}>
                  <span
                    className="absolute inset-y-0 left-0 w-1 bg-purple-600 rounded-tr-lg rounded-br-lg"
                    aria-hidden="true"
                  ></span>
                </Route>
                <Icon
                  className="w-5 h-5"
                  aria-hidden="true"
                  icon={route.icon}
                />
                <span className="ml-4">{route.name}</span>
              </NavLink>
            </li>
          )
        )}
      </ul>
      <div className="px-6 my-6">
        <Button onClick={handleSignOut}>Sign Out &rarr;</Button>
      </div>
    </div>
  );
}

export default SidebarContent;
